import React, { useState } from 'react';
import { Grid, Typography, Paper, Card, CardContent, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    overflow: 'hidden',
    '&:hover $image': {
      transform: 'scale(1.05)',
    },
  },
  image: {
    width: '100%',
    borderRadius: '5%',
    transition: 'transform 0.3s ease-in-out',
  },
}));

const MyCard = () => {
    const classes = useStyles();
  
    return (
      <Card className={classes.card}>
        <CardContent>
          <Grid container direction='column'>
            <Grid item md={12} sx={{border:'0.5px solig grey', borderRadius: '5%', overflow:'hidden'}}>
              <img
                src="https://reno.b-cdn.net/wp-content/uploads/2014/05/12-1-525x328.webp"
                alt="property_image"
                className={classes.image}
              />
            </Grid>
            <Grid item md={12} mt={1.5}>
              <Grid container spacing={0.5}>
                <Grid item md={12}>
                  <Typography variant="body2" fontWeight='bold' color='#249fcf'>$ 20,000.00</Typography>
                </Grid>
                <Grid item md={12}>
                  <Typography variant="body1" fontWeight='bold' color="#249fcf">Penthouse with 360 Infinity Pool</Typography>
                </Grid>
                <Grid item md={12}>
                  <Typography variant='subtitle2'>Just steps away from QM2 express bus to Manhattan and local buses; only min ...</Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid item md={12}>
                <Button variant="contained" sx={{float:'right'}}><Typography variant="overline" fontWeight="bold">Edit</Typography></Button>
            </Grid> */}
          </Grid>
        </CardContent>
      </Card>
    );
  };


const Dashboard = () => {
  const [activeContent, setActiveContent] = useState('Profile');

  const handleHeaderClick = (contentName) => {
    setActiveContent(contentName);
  };

  const renderContent = () => {
    switch(activeContent) {
      case 'Profile':
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{display:'flex',direction:'row'}}>
                    <Typography variant="h6" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Name:
                    </Typography>
                    <Typography variant="h6" style={{ marginLeft: '10px', color: '#000' }}>
                    John Doe
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{display:'flex',direction:'row'}}>
                    <Typography variant="h6" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Phone:
                    </Typography>
                    <Typography variant="h6" style={{ marginLeft: '10px', color: '#000' }}>
                    (123) 456-7890
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{display:'flex',direction:'row'}}>
                    <Typography variant="h6" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Email:
                    </Typography>
                    <Typography variant="h6" style={{ marginLeft: '10px', color: '#000' }}>
                    john.doe@example.com
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{display:'flex',direction:'row'}}>
                    <Typography variant="h6" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Type:
                    </Typography>
                    <Typography variant="h6" style={{ marginLeft: '10px', color: '#000' }}>
                    Admin
                    </Typography>
                </Grid>
            </Grid>
        );
      case 'Properties':
        return (
            <Grid container spacing={2}>
                {[1, 2, 3, 4, 5, 6].map((property, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                    <MyCard  />
                    </Grid>
                ))}
            </Grid>
        );
      case 'Others':
        return <div>Other content goes here.</div>;
      default:
        return <div>Select an option above.</div>;
    }
  };

  const isActive = (header) => activeContent === header;

  return (
    <Grid
    container
    spacing={2}
    sx={{ padding: '20px', marginTop: { xs: '50px', sm: '50px', md: '100px' } }}
    >
      <Grid item xs={12}>
        <Grid container spacing={2} justifyContent="space-around">
          <Grid item>
            <Paper 
              elevation={isActive('Profile') ? 6 : 3} 
              onClick={() => handleHeaderClick('Profile')} 
              style={{
                padding: '10px', 
                cursor: 'pointer', 
                textAlign: 'center',
                backgroundColor: isActive('Profile') ? '#1976d2' : '#ffffff',
                color: isActive('Profile') ? '#ffffff' : '#000000'
              }}
            >
              <Typography variant="overline" fontWeight="bold">Profile</Typography>
            </Paper>
          </Grid>
          <Grid item>
            <Paper 
              elevation={isActive('Properties') ? 6 : 3} 
              onClick={() => handleHeaderClick('Properties')} 
              style={{
                padding: '10px', 
                cursor: 'pointer', 
                textAlign: 'center',
                backgroundColor: isActive('Properties') ? '#1976d2' : '#ffffff',
                color: isActive('Properties') ? '#ffffff' : '#000000'
              }}
            >
              <Typography variant="overline" fontWeight="bold">Properties</Typography>
            </Paper>
          </Grid>
          <Grid item>
            <Paper 
              elevation={isActive('Others') ? 6 : 3} 
              onClick={() => handleHeaderClick('Others')} 
              style={{
                padding: '10px', 
                cursor: 'pointer', 
                textAlign: 'center',
                backgroundColor: isActive('Others') ? '#1976d2' : '#ffffff',
                color: isActive('Others') ? '#ffffff' : '#000000'
              }}
            >
              <Typography variant="overline" fontWeight="bold">Others</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Paper elevation={3} style={{ padding: '20px' }}>
          {renderContent()}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
